import React, {Component} from 'react';
import Icon from "./Icon";
import VoteApi from "../api/VoteApi";
import WithUserState from "./user/WithUserState";
import SignInButton from "./user/SignInButton";
import PropTypes from "prop-types";

class VoteButton extends Component {
  static propTypes = {
    object: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    voteData: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      key: [props.object.type, props.object.slug].join("-"),
      voted: props.active || props.voteData.voted === this.props.type,
      loading: false
    };

    this.onVoteChange = this.onVoteChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      voted: localStorage.getItem(this.state.key) === this.props.type
    });

    window.addEventListener('voteDataChanged', this.onVoteChange);
  }

  componentWillUnmount() {
    window.removeEventListener('voteDataChanged', this.onVoteChange);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.voteData.voted !== this.props.voteData.voted) {
      this.setState({
        voted: this.props.voteData.voted === this.props.type
      })
    }
  }

  onButtonClick(e) {
    const { object, type } = this.props;
    e.preventDefault();

    if (this.state.loading) {
      return;
    }

    localStorage.setItem(this.state.key, type);
    this.setState({
      loading: true,
      voted: localStorage.getItem(this.state.key) === type
    }, () => {
      VoteApi.vote(object.type, object.slug, type).then(() => {
        window.dispatchEvent(new Event('voteDataChanged'));
        this.setState({
          loading: false
        })
      });
    });
  }

  onVoteChange() {
    const { type } = this.props;

    this.setState({
      voted: localStorage.getItem(this.state.key) === type
    });
  }

  render() {
    let classes = ["btn btn-block"];
    if (this.props.className) {
      classes.push(this.props.className);
    }

    if (this.state.voted) {
      classes.push("btn-primary");
    } else {
      classes.push("btn-default");
    }

    switch (this.props.type) {
      case "dislike":
        return (
          <React.Fragment>
            <WithUserState state={'loggedIn'}>
              <button className={classes.join(" ")} onClick={this.onButtonClick.bind(this)}><Icon icon={'thumbs-down'}/> Dislike</button>
            </WithUserState>
            <WithUserState state={'loggedOut'}>
              <SignInButton className={classes.join(" ")}><Icon icon={'thumbs-down'}/> Dislike</SignInButton>
            </WithUserState>
          </React.Fragment>
        );
      default:
        return (
          <button className={classes.join(" ")} onClick={this.onButtonClick.bind(this)}><Icon icon={'thumbs-up'}/> Like</button>
        );
    }
  }
}

export default VoteButton;